import { render, staticRenderFns } from "./txtPreview.vue?vue&type=template&id=75e5af08&scoped=true"
import script from "./txtPreview.vue?vue&type=script&lang=js"
export * from "./txtPreview.vue?vue&type=script&lang=js"
import style0 from "./txtPreview.vue?vue&type=style&index=0&id=75e5af08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e5af08",
  null
  
)

export default component.exports